<div class="student-card p-3 p-md-4 level-{{levelKey || 'default'}}">

  <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between mb-3">
    <div>
      <p class="fs-20 fw-800 color-gray-950 mb-0">{{'planner.title'|translate}}</p>
      <p class="fs-small fw-400 color-gray-400 mb-0">
        {{'planner.subtitle'|translate: {name: studentName} }}
        <span *ngIf="progressLabel()"> · {{'planner.completed_count'|translate: {progress: progressLabel()} }}</span>
      </p>
    </div>

    <div class="d-flex align-items-center mt-3 mt-lg-0">
      <div class="mode-switch d-flex me-3">
        <a class="mode-option text-center fs-small fw-800 clickable px-3 py-1"
           [class.active]="mode === 'lessons'" (click)="setMode('lessons')">
          {{'planner.mode.lessons'|translate}}
        </a>
        <a class="mode-option text-center fs-small fw-800 clickable px-3 py-1"
           [class.active]="mode === 'days'" (click)="setMode('days')">
          {{'planner.mode.days'|translate}}
        </a>
      </div>

      <app-gray-button
        color="primary" [fullWidth]="false" padding="px-3 py-2 gap-1" [weight]="800"
        customClass="d-flex align-items-center fs-small border-8" preIcon="plus"
        [text]="'planner.add_topic'|translate" (click)="openAddTopic()"></app-gray-button>
    </div>
  </div>

  <div class="d-flex flex-wrap gap-2 mb-3">
    <app-gray-button
      color="stroke" [fullWidth]="false" padding="py-1 px-3" [weight]="500" customClass="fs-small"
      [text]="'planner.select_plan'|translate" (click)="openSelectPlan()"></app-gray-button>

    <app-gray-button
      color="stroke" [fullWidth]="false" padding="py-1 px-3" [weight]="500" customClass="fs-small"
      [text]="'planner.delete_plan'|translate" (click)="openDeletePlan()"></app-gray-button>
  </div>

  <ngx-skeleton-loader
    *ngIf="weeksIsLoading" count="1" appearance="line"
    [theme]="{height: '38px', 'border-radius': '999px', margin: '0 0 16px 0'}"/>

  <app-planner-week-pager
    *ngIf="!weeksIsLoading && weeks.length"
    class="d-block mb-3"
    [weeks]="weeks" [selectedWeekId]="selectedWeek?.id"
    (weekSelected)="selectWeek($event)"></app-planner-week-pager>

  <ngx-skeleton-loader
    *ngIf="itemsIsLoading" count="3" appearance="line"
    [theme]="{height: '120px', 'border-radius': '12px', margin: '0 0 8px 0'}"/>

  <!-- The board is drawn from the lesson catalog, so an empty week still shows its columns. -->
  <app-planner-board
    *ngIf="!itemsIsLoading && weeks.length && lessons.length && mode === 'lessons'"
    [lessons]="lessons" [items]="items" [config]="config"
    (addTopicRequested)="openAddTopic($event)"
    (itemToggled)="toggleItem($event)"
    (itemTransferRequested)="openTransfer($event)"
    (itemDuplicateRequested)="duplicateItem($event)"
    (itemRemoveRequested)="removeItem($event)"></app-planner-board>

  <app-planner-day-board
    *ngIf="!itemsIsLoading && weeks.length && mode === 'days'"
    [weekStart]="selectedWeek?.startedAt" [items]="items" [config]="config"
    (itemAssigned)="onItemAssigned($event)"
    (itemToggled)="toggleItem($event)"
    (itemTransferRequested)="openTransfer($event)"
    (itemDuplicateRequested)="duplicateItem($event)"
    (itemRemoveRequested)="removeItem($event)"></app-planner-day-board>

  <div class="text-center py-4" *ngIf="!weeksIsLoading && !weeks.length">
    <p class="fs-normal fw-800 color-gray-950 mb-1">{{'planner.no_plan_title'|translate}}</p>
    <p class="fs-small fw-400 color-gray-400 mb-0">{{'planner.no_plan_desc'|translate}}</p>
  </div>

</div>
